// GENERATE BY ./generate.js
// DO NOT EDIT IT MANUALLY
import Group from '../icons/Group.svg?react'
import Absolute from '../icons/absolute.svg?react'
import AddCourseAi from '../icons/add-course-ai.svg?react'
import Add from '../icons/add.svg?react'
import AddElement from '../icons/addElement.svg?react'
import AiAdd from '../icons/ai-add.svg?react'
import AiBubble from '../icons/ai-bubble.svg?react'
import Ai from '../icons/ai.svg?react'
import AlertCheck from '../icons/alert-check.svg?react'
import AlertDangerTemp from '../icons/alert-danger-temp.svg?react'
import AlertDanger from '../icons/alert-danger.svg?react'
import AlertFailRed from '../icons/alert-fail-red.svg?react'
import AlertFailWhite from '../icons/alert-fail-white.svg?react'
import AlertInfo from '../icons/alert-info.svg?react'
import AlignmentAlignBottom from '../icons/alignment-align-bottom.svg?react'
import AlignmentAlignCenter from '../icons/alignment-align-center.svg?react'
import AlignmentAlignFull from '../icons/alignment-align-full.svg?react'
import AlignmentAlignLeft from '../icons/alignment-align-left.svg?react'
import AlignmentAlignMid from '../icons/alignment-align-mid.svg?react'
import AlignmentAlignRight from '../icons/alignment-align-right.svg?react'
import AlignmentAlignStretchH from '../icons/alignment-align-stretch-h.svg?react'
import AlignmentAlignStretchV from '../icons/alignment-align-stretch-v.svg?react'
import AlignmentAlignTop from '../icons/alignment-align-top.svg?react'
import Alt from '../icons/alt.svg?react'
import Analytics from '../icons/analytics.svg?react'
import Anchor from '../icons/anchor.svg?react'
import Annotation from '../icons/annotation.svg?react'
import ArrowBackRight from '../icons/arrow-back-right.svg?react'
import ArrowMoreOpenNewTab from '../icons/arrow-more-open new tab.svg?react'
import ArrowRight from '../icons/arrow-right.svg?react'
import ArrowTabs from '../icons/arrow-tabs.svg?react'
import AutoHeight from '../icons/auto-height.svg?react'
import Back20Px from '../icons/back 20px.svg?react'
import Backward from '../icons/backward.svg?react'
import BlocksFill from '../icons/blocks-fill.svg?react'
import Book from '../icons/book.svg?react'
import BookmarkFill from '../icons/bookmark-fill.svg?react'
import BookmarkStroke from '../icons/bookmark-stroke.svg?react'
import BookmarksDoubleFill from '../icons/bookmarks-double-fill.svg?react'
import BorderBottom from '../icons/border-bottom.svg?react'
import BorderFull from '../icons/border-full.svg?react'
import BorderLeft from '../icons/border-left.svg?react'
import BorderOuter from '../icons/border-outer.svg?react'
import BorderRadiusFull from '../icons/border-radius-full.svg?react'
import BorderRadiusLeftBottom from '../icons/border-radius-left-bottom.svg?react'
import BorderRadiusLeftTop from '../icons/border-radius-left-top.svg?react'
import BorderRadiusRightBottom from '../icons/border-radius-right-bottom.svg?react'
import BorderRadiusRightTop from '../icons/border-radius-right-top.svg?react'
import BorderRight from '../icons/border-right.svg?react'
import BorderTop from '../icons/border-top.svg?react'
import BoxCollectionsArchive from '../icons/box-collections-archive.svg?react'
import BuilderAbsolut from '../icons/builder-absolut.svg?react'
import BuilderAddComponent from '../icons/builder-add-component.svg?react'
import BuilderAdd from '../icons/builder-add.svg?react'
import BuilderAi from '../icons/builder-ai.svg?react'
import BuilderAlignCenter from '../icons/builder-align-center.svg?react'
import BuilderAlignFullWidth from '../icons/builder-align-full-width.svg?react'
import BuilderAlignLeft from '../icons/builder-align-left.svg?react'
import BuilderAlignRight from '../icons/builder-align-right.svg?react'
import BuilderArrowDown from '../icons/builder-arrow-down.svg?react'
import BuilderArrowLeft from '../icons/builder-arrow-left.svg?react'
import BuilderArrowRight from '../icons/builder-arrow-right.svg?react'
import BuilderArrowScale from '../icons/builder-arrow-scale.svg?react'
import BuilderArrowUp from '../icons/builder-arrow-up.svg?react'
import BuilderBlockquote from '../icons/builder-blockquote.svg?react'
import BuilderBold from '../icons/builder-bold.svg?react'
import BuilderBottomLeft from '../icons/builder-bottom-left.svg?react'
import BuilderBottomRight from '../icons/builder-bottom-right.svg?react'
import BuilderBottom from '../icons/builder-bottom.svg?react'
import BuilderColumn from '../icons/builder-column.svg?react'
import BuilderContentModeSettings from '../icons/builder-content-mode-settings.svg?react'
import BuilderContent from '../icons/builder-content.svg?react'
import BuilderDesktop from '../icons/builder-desktop.svg?react'
import BuilderDrugAndDrop from '../icons/builder-drug-and-drop.svg?react'
import BuilderDrug from '../icons/builder-drug.svg?react'
import BuilderElement from '../icons/builder-element.svg?react'
import BuilderH1 from '../icons/builder-h-1.svg?react'
import BuilderH2 from '../icons/builder-h-2.svg?react'
import BuilderH3 from '../icons/builder-h-3.svg?react'
import BuilderH4 from '../icons/builder-h-4.svg?react'
import BuilderInputBack from '../icons/builder-input-back.svg?react'
import BuilderInputDown from '../icons/builder-input-down.svg?react'
import BuilderInputForward from '../icons/builder-input-forward.svg?react'
import BuilderInputUp from '../icons/builder-input-up.svg?react'
import BuilderItalic from '../icons/builder-italic.svg?react'
import BuilderLeftDown from '../icons/builder-left-down.svg?react'
import BuilderLeftUp from '../icons/builder-left-up.svg?react'
import BuilderLeft from '../icons/builder-left.svg?react'
import BuilderListNumbers from '../icons/builder-list-numbers.svg?react'
import BuilderList from '../icons/builder-list.svg?react'
import BuilderLock from '../icons/builder-lock.svg?react'
import BuilderLower from '../icons/builder-lower.svg?react'
import BuilderProMode from '../icons/builder-pro-mode.svg?react'
import BuilderPromode2 from '../icons/builder-promode-2.svg?react'
import BuilderRightDown from '../icons/builder-right-down.svg?react'
import BuilderRightUp from '../icons/builder-right-up.svg?react'
import BuilderRight from '../icons/builder-right.svg?react'
import BuilderRow from '../icons/builder-row.svg?react'
import BuilderSpace from '../icons/builder-space.svg?react'
import BuilderSwitchLeft from '../icons/builder-switch-left.svg?react'
import BuilderSwitchRight from '../icons/builder-switch-right.svg?react'
import BuilderSymbol from '../icons/builder-symbol.svg?react'
import BuilderTabBlocks from '../icons/builder-tab-blocks.svg?react'
import BuilderTabLayers from '../icons/builder-tab-layers.svg?react'
import BuilderText from '../icons/builder-text.svg?react'
import BuilderTimeline from '../icons/builder-timeline.svg?react'
import BuilderTooltip from '../icons/builder-tooltip.svg?react'
import BuilderTopLeft from '../icons/builder-top-left.svg?react'
import BuilderTopRight from '../icons/builder-top-right.svg?react'
import BuilderTop from '../icons/builder-top.svg?react'
import BuilderTypeParagraphCharacterAllCaps from '../icons/builder-type-paragraph-character-all-caps.svg?react'
import BuilderTypeParagraphCharacterTextSizeSmall from '../icons/builder-type-paragraph-character-text-size-small.svg?react'
import BuilderTypeParagraphCharacterTextSize from '../icons/builder-type-paragraph-character-text-size.svg?react'
import BuilderUnderline from '../icons/builder-underline.svg?react'
import BuilderUnderlinetextCross from '../icons/builder-underlinetext-cross.svg?react'
import BuilderUpper from '../icons/builder-upper.svg?react'
import BurgerMenu from '../icons/burger-menu.svg?react'
import Cc from '../icons/cc.svg?react'
import ChangeCompany from '../icons/change-company.svg?react'
import Checkbox from '../icons/checkbox.svg?react'
import Checkmark1 from '../icons/checkmark-1.svg?react'
import CheckmarkCircle1 from '../icons/checkmark-circle-1.svg?react'
import Clone from '../icons/clone.svg?react'
import Collapse2Submenu2Reverse from '../icons/collapse-2-submenu-2-reverse.svg?react'
import Collapse2Submenu2 from '../icons/collapse-2-submenu-2.svg?react'
import CollapseOpen from '../icons/collapse-open.svg?react'
import ColumnGap from '../icons/column-gap.svg?react'
import ComplexListActive from '../icons/complex-list-active.svg?react'
import ComplexList from '../icons/complex-list.svg?react'
import Constant from '../icons/constant.svg?react'
import ContentMode from '../icons/content-mode.svg?react'
import ContentsChapter from '../icons/contents-chapter.svg?react'
import ContentsLanding from '../icons/contents-landing.svg?react'
import ContentsSlides from '../icons/contents-slides.svg?react'
import ContentsTest from '../icons/contents-test.svg?react'
import CourseAnswerCorrect from '../icons/course-answer-correct.svg?react'
import CourseAnswerIncorrect from '../icons/course-answer-incorrect.svg?react'
import CourseArrowBack from '../icons/course-arrow-back.svg?react'
import CourseArrowForward from '../icons/course-arrow-forward.svg?react'
import CreateAsset from '../icons/create-asset.svg?react'
import Crop from '../icons/crop.svg?react'
import Dash from '../icons/dash.svg?react'
import Desktop from '../icons/desktop.svg?react'
import DocumentsArchiveLibrary from '../icons/documents-archive-library.svg?react'
import Dots from '../icons/dots.svg?react'
import Drag from '../icons/drag.svg?react'
import EmageMove from '../icons/emage-move.svg?react'
import EmptyColor from '../icons/empty-color.svg?react'
import Energy from '../icons/energy.svg?react'
import Equal from '../icons/equal.svg?react'
import Error from '../icons/error.svg?react'
import ExportDispatch from '../icons/export-dispatch.svg?react'
import ExportHtml from '../icons/export-html.svg?react'
import ExportPdf from '../icons/export-pdf.svg?react'
import ExportScorm from '../icons/export-scorm.svg?react'
import EyeCloseEye from '../icons/eye-close-eye.svg?react'
import EyeOpenEye from '../icons/eye-open-eye.svg?react'
import FacebookOld from '../icons/facebookOld.svg?react'
import FixSpelling from '../icons/fix-spelling.svg?react'
import FlexColumn from '../icons/flex-column.svg?react'
import FlexRow from '../icons/flex-row.svg?react'
import Folder from '../icons/folder.svg?react'
import Forward from '../icons/forward.svg?react'
import Fr from '../icons/fr.svg?react'
import FullSize from '../icons/full-size.svg?react'
import Gear2 from '../icons/gear-2.svg?react'
import Gear from '../icons/gear.svg?react'
import General from '../icons/general.svg?react'
import GradientColor from '../icons/gradient-color.svg?react'
import GraphicTabletDrawPen from '../icons/graphic-tablet-draw-pen.svg?react'
import Grid from '../icons/grid.svg?react'
import HeadphonesSupport from '../icons/headphones-support.svg?react'
import Height from '../icons/height.svg?react'
import HorizontalLeft from '../icons/horizontal_left.svg?react'
import HorizontalRight from '../icons/horizontal_right.svg?react'
import IconBuilderLink from '../icons/icon-builder-link.svg?react'
import IconFillBell from '../icons/icon-fill-bell.svg?react'
import IconFillFolder from '../icons/icon-fill-folder.svg?react'
import IconFillOwner from '../icons/icon-fill-owner.svg?react'
import IconFillStatusMarked from '../icons/icon-fill-status-marked.svg?react'
import IconSendDisabled from '../icons/icon-send-disabled.svg?react'
import IconSend from '../icons/icon-send.svg?react'
import IconStatusSpinner from '../icons/icon-status-spinner.svg?react'
import IconsBuilderLock from '../icons/icons-builder-lock.svg?react'
import IconsExpandLeft from '../icons/icons-expand-left.svg?react'
import IconsExpandRight from '../icons/icons-expand-right.svg?react'
import IconsForElementsDown from '../icons/icons-for-elements-down.svg?react'
import IconsForElementsLeftSlider from '../icons/icons-for-elements-left-slider.svg?react'
import IconsForElementsLeft from '../icons/icons-for-elements-left.svg?react'
import IconsForElementsRightSlider from '../icons/icons-for-elements-right-slider.svg?react'
import IconsForElementsRight from '../icons/icons-for-elements-right.svg?react'
import IconsForElementsRotateRight from '../icons/icons-for-elements-rotate-right.svg?react'
import IconsOtherAddColumn from '../icons/icons-other-add-column.svg?react'
import IconsOtherAddRow from '../icons/icons-other-add-row.svg?react'
import IconsOtherAudio from '../icons/icons-other-audio.svg?react'
import IconsOtherBg from '../icons/icons-other-bg.svg?react'
import IconsOtherBoxHome from '../icons/icons-other-box-home.svg?react'
import IconsOtherButton from '../icons/icons-other-button.svg?react'
import IconsOtherCode from '../icons/icons-other-code.svg?react'
import IconsOtherDistribution from '../icons/icons-other-distribution.svg?react'
import IconsOtherElementCards from '../icons/icons-other-element-cards.svg?react'
import IconsOtherEmbedCode from '../icons/icons-other-embed-code.svg?react'
import IconsOtherFigure from '../icons/icons-other-figure.svg?react'
import IconsOtherFolderCheckmark from '../icons/icons-other-folder-checkmark.svg?react'
import IconsOtherGraphic from '../icons/icons-other-graphic.svg?react'
import IconsOtherHeader from '../icons/icons-other-header.svg?react'
import IconsOtherLanguageTranslateCircle from '../icons/icons-other-language-translate-circle.svg?react'
import IconsOtherLine from '../icons/icons-other-line.svg?react'
import IconsOtherMarginsLandingPages from '../icons/icons-other-margins-landing-pages.svg?react'
import IconsOtherMarginsTestPages from '../icons/icons-other-margins-test-pages.svg?react'
import IconsOtherMore from '../icons/icons-other-more.svg?react'
import IconsOtherMoveTo from '../icons/icons-other-move-to.svg?react'
import IconsOtherNavigationButtons from '../icons/icons-other-navigation-buttons.svg?react'
import IconsOtherNullBg from '../icons/icons-other-null-bg.svg?react'
import IconsOtherProgress from '../icons/icons-other-progress.svg?react'
import IconsOtherResultDescription from '../icons/icons-other-result-description.svg?react'
import IconsOtherResultMarkers from '../icons/icons-other-result-markers.svg?react'
import IconsOtherRow from '../icons/icons-other-row.svg?react'
import IconsOtherSidebar from '../icons/icons-other-sidebar.svg?react'
import IconsOtherSingleChoose from '../icons/icons-other-single-choose.svg?react'
import IconsOtherSlider from '../icons/icons-other-slider.svg?react'
import IconsOtherSwitch from '../icons/icons-other-switch.svg?react'
import IconsOtherTableEditTableEraser from '../icons/icons-other-table-edit-table-eraser.svg?react'
import IconsOtherTable from '../icons/icons-other-table.svg?react'
import IconsOtherTabs from '../icons/icons-other-tabs.svg?react'
import IconsOtherVideo from '../icons/icons-other-video.svg?react'
import IllustrationPageLock from '../icons/illustration-page-lock.svg?react'
import ImagePictureArrow from '../icons/image-picture-arrow.svg?react'
import ImagePicture from '../icons/image-picture.svg?react'
import Image from '../icons/image.svg?react'
import ImproveWriting from '../icons/improve-writing.svg?react'
import Improve from '../icons/improve.svg?react'
import InFlow from '../icons/in-flow.svg?react'
import InfoShareCircle from '../icons/info-share-circle.svg?react'
import InterfaceEssentialAnchor from '../icons/interface-essential-anchor.svg?react'
import KeyCmd from '../icons/key-cmd.svg?react'
import KeyCtrl from '../icons/key-ctrl.svg?react'
import KeyMeta from '../icons/key-meta.svg?react'
import LayersFill from '../icons/layers-fill.svg?react'
import LifeRingHelpSupportBug from '../icons/life-ring-help-support-bug.svg?react'
import Link2 from '../icons/link-2.svg?react'
import LinkArrow from '../icons/link-arrow.svg?react'
import LinkToResource from '../icons/link-to-resource.svg?react'
import LinkedinOld from '../icons/linkedinOld.svg?react'
import LockOff from '../icons/lock-off.svg?react'
import Lock from '../icons/lock.svg?react'
import MainManuCourses from '../icons/main-manu-courses.svg?react'
import MainMenuBackButton from '../icons/main-menu-back-button.svg?react'
import MainMenuBell from '../icons/main-menu-bell.svg?react'
import MainMenuBranding from '../icons/main-menu-branding.svg?react'
import MainMenuDashboard from '../icons/main-menu-dashboard.svg?react'
import MainMenuFiles from '../icons/main-menu-files.svg?react'
import MainMenuFont from '../icons/main-menu-font.svg?react'
import MainMenuProjects from '../icons/main-menu-projects.svg?react'
import MainMenuSettings from '../icons/main-menu-settings.svg?react'
import MainMenuTags from '../icons/main-menu-tags.svg?react'
import MainMenuTasks from '../icons/main-menu-tasks.svg?react'
import MainMenuUsers from '../icons/main-menu-users.svg?react'
import MakeLonger from '../icons/make-longer.svg?react'
import MakeShorter from '../icons/make-shorter.svg?react'
import MarginsBottom from '../icons/margins_bottom.svg?react'
import MarginsLeft from '../icons/margins_left.svg?react'
import MarginsLeftRight from '../icons/margins_left_right.svg?react'
import MarginsRight from '../icons/margins_right.svg?react'
import MarginsUp from '../icons/margins_up.svg?react'
import MarginsUpBottom from '../icons/margins_up_bottom.svg?react'
import Markdown from '../icons/markdown.svg?react'
import MaxHeight from '../icons/maxHeight.svg?react'
import MaxWidth from '../icons/maxWidth.svg?react'
import MenuBurgerCircle2 from '../icons/menu-burger-circle-2.svg?react'
import MenuBurgerSquare from '../icons/menu-burger-square.svg?react'
import Menu from '../icons/menu.svg?react'
import MessageFilterApplied from '../icons/message-filter-applied.svg?react'
import MessageFilter from '../icons/message-filter.svg?react'
import MessagesChatRegular from '../icons/messages-chat-regular.svg?react'
import MessagesPickerApplied from '../icons/messages-picker-applied.svg?react'
import MessagesPicker from '../icons/messages-picker.svg?react'
import MessagesReply from '../icons/messages-reply.svg?react'
import MinHeight from '../icons/minHeight.svg?react'
import MinWidth from '../icons/minWidth.svg?react'
import MinusThin from '../icons/minus-thin.svg?react'
import MissingFont from '../icons/missing-font.svg?react'
import Mobile from '../icons/mobile.svg?react'
import MouseButtonLeft from '../icons/mouse-button-left.svg?react'
import MouseButtonRight from '../icons/mouse-button-right.svg?react'
import Move from '../icons/move.svg?react'
import NewPro from '../icons/new-pro.svg?react'
import ObjectRotate from '../icons/object-rotate.svg?react'
import OnAppear from '../icons/on appear.svg?react'
import OnClick from '../icons/on click.svg?react'
import Opacity from '../icons/opacity.svg?react'
import OpenLink from '../icons/open-link.svg?react'
import Original from '../icons/original.svg?react'
import OtherAdd from '../icons/other-add.svg?react'
import OtherAlert from '../icons/other-alert.svg?react'
import OtherApllay from '../icons/other-apllay.svg?react'
import OtherArchive from '../icons/other-archive.svg?react'
import OtherArroworeOpenNewTab from '../icons/other-arrowore-open-new-tab.svg?react'
import OtherAsk from '../icons/other-ask.svg?react'
import OtherBack from '../icons/other-back.svg?react'
import OtherBg from '../icons/other-bg.svg?react'
import OtherBlock from '../icons/other-block.svg?react'
import OtherBrokenLink from '../icons/other-broken-link.svg?react'
import OtherBurger from '../icons/other-burger.svg?react'
import OtherCalendar from '../icons/other-calendar.svg?react'
import OtherCards from '../icons/other-cards.svg?react'
import OtherCircleCrop from '../icons/other-circle-crop.svg?react'
import OtherClock from '../icons/other-clock.svg?react'
import OtherClose from '../icons/other-close.svg?react'
import OtherCopy from '../icons/other-copy.svg?react'
import OtherCrop from '../icons/other-crop.svg?react'
import OtherDown from '../icons/other-down.svg?react'
import OtherDownload from '../icons/other-download.svg?react'
import OtherEnter from '../icons/other-enter.svg?react'
import OtherFile from '../icons/other-file.svg?react'
import OtherFolder from '../icons/other-folder.svg?react'
import OtherFont from '../icons/other-font.svg?react'
import OtherFullScreen from '../icons/other-full-screen.svg?react'
import OtherImage from '../icons/other-image.svg?react'
import OtherLeft from '../icons/other-left.svg?react'
import OtherLinkToResource from '../icons/other-link-to-resource.svg?react'
import OtherList from '../icons/other-list.svg?react'
import OtherLock from '../icons/other-lock.svg?react'
import OtherMessages from '../icons/other-messages.svg?react'
import OtherPause from '../icons/other-pause.svg?react'
import OtherPlay from '../icons/other-play.svg?react'
import OtherRefresh from '../icons/other-refresh.svg?react'
import OtherReload from '../icons/other-reload.svg?react'
import OtherReset from '../icons/other-reset.svg?react'
import OtherRight from '../icons/other-right.svg?react'
import OtherSmallScreen from '../icons/other-small-screen.svg?react'
import OtherSort from '../icons/other-sort.svg?react'
import OtherSquare from '../icons/other-square.svg?react'
import OtherSwitch from '../icons/other-switch.svg?react'
import OtherTask from '../icons/other-task.svg?react'
import OtherText from '../icons/other-text.svg?react'
import OtherTrashDeleteBin24Px from '../icons/other-trash-delete-bin-24-px.svg?react'
import OtherTrashDeleteBin from '../icons/other-trash-delete-bin.svg?react'
import OtherTrash from '../icons/other-trash.svg?react'
import OtherUndo from '../icons/other-undo.svg?react'
import OtherUp from '../icons/other-up.svg?react'
import OtherZoom from '../icons/other-zoom.svg?react'
import Other from '../icons/other.svg?react'
import OutOfFlow from '../icons/out-of-flow.svg?react'
import PaddingBottom from '../icons/padding_bottom.svg?react'
import PaddingLeft from '../icons/padding_left.svg?react'
import PaddingLeftRight from '../icons/padding_left_right.svg?react'
import PaddingRight from '../icons/padding_right.svg?react'
import PaddingUp from '../icons/padding_up.svg?react'
import PaddingUpBottom from '../icons/padding_up_bottom.svg?react'
import Paddings from '../icons/paddings.svg?react'
import PasswordFail from '../icons/password-fail.svg?react'
import PasswordSuccess from '../icons/password-success.svg?react'
import PenEdit from '../icons/pen-edit.svg?react'
import Percent from '../icons/percent.svg?react'
import PinFill from '../icons/pin-fill.svg?react'
import Pin from '../icons/pin.svg?react'
import Pixel from '../icons/pixel.svg?react'
import Play2 from '../icons/play-2.svg?react'
import PlayLoading from '../icons/play-loading.svg?react'
import Play from '../icons/play.svg?react'
import Polygon from '../icons/polygon.svg?react'
import PortalBroadcast from '../icons/portal-broadcast.svg?react'
import PortfolioOld from '../icons/portfolioOld.svg?react'
import ProMode from '../icons/pro-mode.svg?react'
import Prompt from '../icons/prompt.svg?react'
import ProtectionSecurityKey from '../icons/protection-security-key.svg?react'
import Repeatable from '../icons/repeatable.svg?react'
import Replace from '../icons/replace.svg?react'
import Restore from '../icons/restore.svg?react'
import RightPanelCollapse from '../icons/right panel collapse.svg?react'
import Rotate from '../icons/rotate.svg?react'
import RowGap from '../icons/row-gap.svg?react'
import ScrollDown from '../icons/scroll-down.svg?react'
import SearchField from '../icons/search-field.svg?react'
import Search from '../icons/search.svg?react'
import Send from '../icons/send.svg?react'
import SettingsSwitches from '../icons/settings-switches.svg?react'
import Settings from '../icons/settings.svg?react'
import Shift from '../icons/shift.svg?react'
import SimplifyLanguage from '../icons/simplify-language.svg?react'
import Simplify from '../icons/simplify.svg?react'
import SingleUserSales from '../icons/single-user-sales.svg?react'
import SmallSize from '../icons/small-size.svg?react'
import SolidColor from '../icons/solid-color.svg?react'
import Solid from '../icons/solid.svg?react'
import Sort from '../icons/sort.svg?react'
import Spinner from '../icons/spinner.svg?react'
import Splitter from '../icons/splitter.svg?react'
import Stash from '../icons/stash.svg?react'
import StatusApply from '../icons/status-apply.svg?react'
import StatusBack from '../icons/status-back.svg?react'
import StatusBug from '../icons/status-bug.svg?react'
import StatusComments from '../icons/status-comments.svg?react'
import StatusDanger20Px from '../icons/status-danger-20-px.svg?react'
import StatusDeadline20Px from '../icons/status-deadline-20-px.svg?react'
import StatusFail20Px from '../icons/status-fail-20-px.svg?react'
import StatusFail from '../icons/status-fail.svg?react'
import StatusGear24Px from '../icons/status-gear-24-px.svg?react'
import StatusHide20Px from '../icons/status-hide-20-px.svg?react'
import StatusLink20Px from '../icons/status-link-20-px.svg?react'
import StatusLock20Px from '../icons/status-lock-20-px.svg?react'
import StatusPending from '../icons/status-pending.svg?react'
import StatusSuccess20Px from '../icons/status-success-20-px.svg?react'
import StatusSumm20Px from '../icons/status-summ-20-px.svg?react'
import StatusSumm24Px from '../icons/status-summ-24-px.svg?react'
import StopPlay from '../icons/stop-Play.svg?react'
import Success from '../icons/success.svg?react'
import Switch from '../icons/switch.svg?react'
import Tablet from '../icons/tablet.svg?react'
import TaskBacklog from '../icons/task-backlog.svg?react'
import TaskDone from '../icons/task-done.svg?react'
import TaskInProgress from '../icons/task-in-progress.svg?react'
import TaskNew from '../icons/task-new.svg?react'
import TaskReview from '../icons/task-review.svg?react'
import Technical from '../icons/technical.svg?react'
import TestResultsNumberOfAttempts from '../icons/test-results-number-of-attempts.svg?react'
import TestResultsPercent from '../icons/test-results-percent.svg?react'
import TestResultsRightQuestions from '../icons/test-results-right-questions.svg?react'
import TestResultsTestTime from '../icons/test-results-test-time.svg?react'
import TextDown from '../icons/text-down.svg?react'
import Tie from '../icons/tie.svg?react'
import TrashDeleteBin from '../icons/trash-delete-bin.svg?react'
import TwitterOld from '../icons/twitterOld.svg?react'
import Ungroup from '../icons/ungroup.svg?react'
import UserApply from '../icons/user-apply.svg?react'
import UserBlock from '../icons/user-block.svg?react'
import UserEmailSentOld from '../icons/user-email-sentOld.svg?react'
import UserValidatedOld from '../icons/user-validatedOld.svg?react'
import VerticalDown from '../icons/vertical_down.svg?react'
import VerticalUp from '../icons/vertical_up.svg?react'
import VolumeHalf from '../icons/volume-half.svg?react'
import Wand from '../icons/wand.svg?react'
import WhileHovering from '../icons/while hovering.svg?react'
import Width from '../icons/width.svg?react'
import Wrap from '../icons/wrap.svg?react'
import ZoomFit from '../icons/zoom-fit.svg?react'

export const ICON_MAP = {
  group: Group,
  absolute: Absolute,
  addCourseAi: AddCourseAi,
  add: Add,
  addElement: AddElement,
  aiAdd: AiAdd,
  aiBubble: AiBubble,
  ai: Ai,
  alertCheck: AlertCheck,
  alertDangerTemp: AlertDangerTemp,
  alertDanger: AlertDanger,
  alertFailRed: AlertFailRed,
  alertFailWhite: AlertFailWhite,
  alertInfo: AlertInfo,
  alignmentAlignBottom: AlignmentAlignBottom,
  alignmentAlignCenter: AlignmentAlignCenter,
  alignmentAlignFull: AlignmentAlignFull,
  alignmentAlignLeft: AlignmentAlignLeft,
  alignmentAlignMid: AlignmentAlignMid,
  alignmentAlignRight: AlignmentAlignRight,
  alignmentAlignStretchH: AlignmentAlignStretchH,
  alignmentAlignStretchV: AlignmentAlignStretchV,
  alignmentAlignTop: AlignmentAlignTop,
  alt: Alt,
  analytics: Analytics,
  anchor: Anchor,
  annotation: Annotation,
  arrowBackRight: ArrowBackRight,
  arrowMoreOpenNewTab: ArrowMoreOpenNewTab,
  arrowRight: ArrowRight,
  arrowTabs: ArrowTabs,
  autoHeight: AutoHeight,
  back20Px: Back20Px,
  backward: Backward,
  blocksFill: BlocksFill,
  book: Book,
  bookmarkFill: BookmarkFill,
  bookmarkStroke: BookmarkStroke,
  bookmarksDoubleFill: BookmarksDoubleFill,
  borderBottom: BorderBottom,
  borderFull: BorderFull,
  borderLeft: BorderLeft,
  borderOuter: BorderOuter,
  borderRadiusFull: BorderRadiusFull,
  borderRadiusLeftBottom: BorderRadiusLeftBottom,
  borderRadiusLeftTop: BorderRadiusLeftTop,
  borderRadiusRightBottom: BorderRadiusRightBottom,
  borderRadiusRightTop: BorderRadiusRightTop,
  borderRight: BorderRight,
  borderTop: BorderTop,
  boxCollectionsArchive: BoxCollectionsArchive,
  builderAbsolut: BuilderAbsolut,
  builderAddComponent: BuilderAddComponent,
  builderAdd: BuilderAdd,
  builderAi: BuilderAi,
  builderAlignCenter: BuilderAlignCenter,
  builderAlignFullWidth: BuilderAlignFullWidth,
  builderAlignLeft: BuilderAlignLeft,
  builderAlignRight: BuilderAlignRight,
  builderArrowDown: BuilderArrowDown,
  builderArrowLeft: BuilderArrowLeft,
  builderArrowRight: BuilderArrowRight,
  builderArrowScale: BuilderArrowScale,
  builderArrowUp: BuilderArrowUp,
  builderBlockquote: BuilderBlockquote,
  builderBold: BuilderBold,
  builderBottomLeft: BuilderBottomLeft,
  builderBottomRight: BuilderBottomRight,
  builderBottom: BuilderBottom,
  builderColumn: BuilderColumn,
  builderContentModeSettings: BuilderContentModeSettings,
  builderContent: BuilderContent,
  builderDesktop: BuilderDesktop,
  builderDrugAndDrop: BuilderDrugAndDrop,
  builderDrug: BuilderDrug,
  builderElement: BuilderElement,
  builderH1: BuilderH1,
  builderH2: BuilderH2,
  builderH3: BuilderH3,
  builderH4: BuilderH4,
  builderInputBack: BuilderInputBack,
  builderInputDown: BuilderInputDown,
  builderInputForward: BuilderInputForward,
  builderInputUp: BuilderInputUp,
  builderItalic: BuilderItalic,
  builderLeftDown: BuilderLeftDown,
  builderLeftUp: BuilderLeftUp,
  builderLeft: BuilderLeft,
  builderListNumbers: BuilderListNumbers,
  builderList: BuilderList,
  builderLock: BuilderLock,
  builderLower: BuilderLower,
  builderProMode: BuilderProMode,
  builderPromode2: BuilderPromode2,
  builderRightDown: BuilderRightDown,
  builderRightUp: BuilderRightUp,
  builderRight: BuilderRight,
  builderRow: BuilderRow,
  builderSpace: BuilderSpace,
  builderSwitchLeft: BuilderSwitchLeft,
  builderSwitchRight: BuilderSwitchRight,
  builderSymbol: BuilderSymbol,
  builderTabBlocks: BuilderTabBlocks,
  builderTabLayers: BuilderTabLayers,
  builderText: BuilderText,
  builderTimeline: BuilderTimeline,
  builderTooltip: BuilderTooltip,
  builderTopLeft: BuilderTopLeft,
  builderTopRight: BuilderTopRight,
  builderTop: BuilderTop,
  builderTypeParagraphCharacterAllCaps: BuilderTypeParagraphCharacterAllCaps,
  builderTypeParagraphCharacterTextSizeSmall: BuilderTypeParagraphCharacterTextSizeSmall,
  builderTypeParagraphCharacterTextSize: BuilderTypeParagraphCharacterTextSize,
  builderUnderline: BuilderUnderline,
  builderUnderlinetextCross: BuilderUnderlinetextCross,
  builderUpper: BuilderUpper,
  burgerMenu: BurgerMenu,
  cc: Cc,
  changeCompany: ChangeCompany,
  checkbox: Checkbox,
  checkmark1: Checkmark1,
  checkmarkCircle1: CheckmarkCircle1,
  clone: Clone,
  collapse2Submenu2Reverse: Collapse2Submenu2Reverse,
  collapse2Submenu2: Collapse2Submenu2,
  collapseOpen: CollapseOpen,
  columnGap: ColumnGap,
  complexListActive: ComplexListActive,
  complexList: ComplexList,
  constant: Constant,
  contentMode: ContentMode,
  contentsChapter: ContentsChapter,
  contentsLanding: ContentsLanding,
  contentsSlides: ContentsSlides,
  contentsTest: ContentsTest,
  courseAnswerCorrect: CourseAnswerCorrect,
  courseAnswerIncorrect: CourseAnswerIncorrect,
  courseArrowBack: CourseArrowBack,
  courseArrowForward: CourseArrowForward,
  createAsset: CreateAsset,
  crop: Crop,
  dash: Dash,
  desktop: Desktop,
  documentsArchiveLibrary: DocumentsArchiveLibrary,
  dots: Dots,
  drag: Drag,
  emageMove: EmageMove,
  emptyColor: EmptyColor,
  energy: Energy,
  equal: Equal,
  error: Error,
  exportDispatch: ExportDispatch,
  exportHtml: ExportHtml,
  exportPdf: ExportPdf,
  exportScorm: ExportScorm,
  eyeCloseEye: EyeCloseEye,
  eyeOpenEye: EyeOpenEye,
  facebookOld: FacebookOld,
  fixSpelling: FixSpelling,
  flexColumn: FlexColumn,
  flexRow: FlexRow,
  folder: Folder,
  forward: Forward,
  fr: Fr,
  fullSize: FullSize,
  gear2: Gear2,
  gear: Gear,
  general: General,
  gradientColor: GradientColor,
  graphicTabletDrawPen: GraphicTabletDrawPen,
  grid: Grid,
  headphonesSupport: HeadphonesSupport,
  height: Height,
  horizontalLeft: HorizontalLeft,
  horizontalRight: HorizontalRight,
  iconBuilderLink: IconBuilderLink,
  iconFillBell: IconFillBell,
  iconFillFolder: IconFillFolder,
  iconFillOwner: IconFillOwner,
  iconFillStatusMarked: IconFillStatusMarked,
  iconSendDisabled: IconSendDisabled,
  iconSend: IconSend,
  iconStatusSpinner: IconStatusSpinner,
  iconsBuilderLock: IconsBuilderLock,
  iconsExpandLeft: IconsExpandLeft,
  iconsExpandRight: IconsExpandRight,
  iconsForElementsDown: IconsForElementsDown,
  iconsForElementsLeftSlider: IconsForElementsLeftSlider,
  iconsForElementsLeft: IconsForElementsLeft,
  iconsForElementsRightSlider: IconsForElementsRightSlider,
  iconsForElementsRight: IconsForElementsRight,
  iconsForElementsRotateRight: IconsForElementsRotateRight,
  iconsOtherAddColumn: IconsOtherAddColumn,
  iconsOtherAddRow: IconsOtherAddRow,
  iconsOtherAudio: IconsOtherAudio,
  iconsOtherBg: IconsOtherBg,
  iconsOtherBoxHome: IconsOtherBoxHome,
  iconsOtherButton: IconsOtherButton,
  iconsOtherCode: IconsOtherCode,
  iconsOtherDistribution: IconsOtherDistribution,
  iconsOtherElementCards: IconsOtherElementCards,
  iconsOtherEmbedCode: IconsOtherEmbedCode,
  iconsOtherFigure: IconsOtherFigure,
  iconsOtherFolderCheckmark: IconsOtherFolderCheckmark,
  iconsOtherGraphic: IconsOtherGraphic,
  iconsOtherHeader: IconsOtherHeader,
  iconsOtherLanguageTranslateCircle: IconsOtherLanguageTranslateCircle,
  iconsOtherLine: IconsOtherLine,
  iconsOtherMarginsLandingPages: IconsOtherMarginsLandingPages,
  iconsOtherMarginsTestPages: IconsOtherMarginsTestPages,
  iconsOtherMore: IconsOtherMore,
  iconsOtherMoveTo: IconsOtherMoveTo,
  iconsOtherNavigationButtons: IconsOtherNavigationButtons,
  iconsOtherNullBg: IconsOtherNullBg,
  iconsOtherProgress: IconsOtherProgress,
  iconsOtherResultDescription: IconsOtherResultDescription,
  iconsOtherResultMarkers: IconsOtherResultMarkers,
  iconsOtherRow: IconsOtherRow,
  iconsOtherSidebar: IconsOtherSidebar,
  iconsOtherSingleChoose: IconsOtherSingleChoose,
  iconsOtherSlider: IconsOtherSlider,
  iconsOtherSwitch: IconsOtherSwitch,
  iconsOtherTableEditTableEraser: IconsOtherTableEditTableEraser,
  iconsOtherTable: IconsOtherTable,
  iconsOtherTabs: IconsOtherTabs,
  iconsOtherVideo: IconsOtherVideo,
  illustrationPageLock: IllustrationPageLock,
  imagePictureArrow: ImagePictureArrow,
  imagePicture: ImagePicture,
  image: Image,
  improveWriting: ImproveWriting,
  improve: Improve,
  inFlow: InFlow,
  infoShareCircle: InfoShareCircle,
  interfaceEssentialAnchor: InterfaceEssentialAnchor,
  keyCmd: KeyCmd,
  keyCtrl: KeyCtrl,
  keyMeta: KeyMeta,
  layersFill: LayersFill,
  lifeRingHelpSupportBug: LifeRingHelpSupportBug,
  link2: Link2,
  linkArrow: LinkArrow,
  linkToResource: LinkToResource,
  linkedinOld: LinkedinOld,
  lockOff: LockOff,
  lock: Lock,
  mainManuCourses: MainManuCourses,
  mainMenuBackButton: MainMenuBackButton,
  mainMenuBell: MainMenuBell,
  mainMenuBranding: MainMenuBranding,
  mainMenuDashboard: MainMenuDashboard,
  mainMenuFiles: MainMenuFiles,
  mainMenuFont: MainMenuFont,
  mainMenuProjects: MainMenuProjects,
  mainMenuSettings: MainMenuSettings,
  mainMenuTags: MainMenuTags,
  mainMenuTasks: MainMenuTasks,
  mainMenuUsers: MainMenuUsers,
  makeLonger: MakeLonger,
  makeShorter: MakeShorter,
  marginsBottom: MarginsBottom,
  marginsLeft: MarginsLeft,
  marginsLeftRight: MarginsLeftRight,
  marginsRight: MarginsRight,
  marginsUp: MarginsUp,
  marginsUpBottom: MarginsUpBottom,
  markdown: Markdown,
  maxHeight: MaxHeight,
  maxWidth: MaxWidth,
  menuBurgerCircle2: MenuBurgerCircle2,
  menuBurgerSquare: MenuBurgerSquare,
  menu: Menu,
  messageFilterApplied: MessageFilterApplied,
  messageFilter: MessageFilter,
  messagesChatRegular: MessagesChatRegular,
  messagesPickerApplied: MessagesPickerApplied,
  messagesPicker: MessagesPicker,
  messagesReply: MessagesReply,
  minHeight: MinHeight,
  minWidth: MinWidth,
  minusThin: MinusThin,
  missingFont: MissingFont,
  mobile: Mobile,
  mouseButtonLeft: MouseButtonLeft,
  mouseButtonRight: MouseButtonRight,
  move: Move,
  newPro: NewPro,
  objectRotate: ObjectRotate,
  onAppear: OnAppear,
  onClick: OnClick,
  opacity: Opacity,
  openLink: OpenLink,
  original: Original,
  otherAdd: OtherAdd,
  otherAlert: OtherAlert,
  otherApllay: OtherApllay,
  otherArchive: OtherArchive,
  otherArroworeOpenNewTab: OtherArroworeOpenNewTab,
  otherAsk: OtherAsk,
  otherBack: OtherBack,
  otherBg: OtherBg,
  otherBlock: OtherBlock,
  otherBrokenLink: OtherBrokenLink,
  otherBurger: OtherBurger,
  otherCalendar: OtherCalendar,
  otherCards: OtherCards,
  otherCircleCrop: OtherCircleCrop,
  otherClock: OtherClock,
  otherClose: OtherClose,
  otherCopy: OtherCopy,
  otherCrop: OtherCrop,
  otherDown: OtherDown,
  otherDownload: OtherDownload,
  otherEnter: OtherEnter,
  otherFile: OtherFile,
  otherFolder: OtherFolder,
  otherFont: OtherFont,
  otherFullScreen: OtherFullScreen,
  otherImage: OtherImage,
  otherLeft: OtherLeft,
  otherLinkToResource: OtherLinkToResource,
  otherList: OtherList,
  otherLock: OtherLock,
  otherMessages: OtherMessages,
  otherPause: OtherPause,
  otherPlay: OtherPlay,
  otherRefresh: OtherRefresh,
  otherReload: OtherReload,
  otherReset: OtherReset,
  otherRight: OtherRight,
  otherSmallScreen: OtherSmallScreen,
  otherSort: OtherSort,
  otherSquare: OtherSquare,
  otherSwitch: OtherSwitch,
  otherTask: OtherTask,
  otherText: OtherText,
  otherTrashDeleteBin24Px: OtherTrashDeleteBin24Px,
  otherTrashDeleteBin: OtherTrashDeleteBin,
  otherTrash: OtherTrash,
  otherUndo: OtherUndo,
  otherUp: OtherUp,
  otherZoom: OtherZoom,
  other: Other,
  outOfFlow: OutOfFlow,
  paddingBottom: PaddingBottom,
  paddingLeft: PaddingLeft,
  paddingLeftRight: PaddingLeftRight,
  paddingRight: PaddingRight,
  paddingUp: PaddingUp,
  paddingUpBottom: PaddingUpBottom,
  paddings: Paddings,
  passwordFail: PasswordFail,
  passwordSuccess: PasswordSuccess,
  penEdit: PenEdit,
  percent: Percent,
  pinFill: PinFill,
  pin: Pin,
  pixel: Pixel,
  play2: Play2,
  playLoading: PlayLoading,
  play: Play,
  polygon: Polygon,
  portalBroadcast: PortalBroadcast,
  portfolioOld: PortfolioOld,
  proMode: ProMode,
  prompt: Prompt,
  protectionSecurityKey: ProtectionSecurityKey,
  repeatable: Repeatable,
  replace: Replace,
  restore: Restore,
  rightPanelCollapse: RightPanelCollapse,
  rotate: Rotate,
  rowGap: RowGap,
  scrollDown: ScrollDown,
  searchField: SearchField,
  search: Search,
  send: Send,
  settingsSwitches: SettingsSwitches,
  settings: Settings,
  shift: Shift,
  simplifyLanguage: SimplifyLanguage,
  simplify: Simplify,
  singleUserSales: SingleUserSales,
  smallSize: SmallSize,
  solidColor: SolidColor,
  solid: Solid,
  sort: Sort,
  spinner: Spinner,
  splitter: Splitter,
  stash: Stash,
  statusApply: StatusApply,
  statusBack: StatusBack,
  statusBug: StatusBug,
  statusComments: StatusComments,
  statusDanger20Px: StatusDanger20Px,
  statusDeadline20Px: StatusDeadline20Px,
  statusFail20Px: StatusFail20Px,
  statusFail: StatusFail,
  statusGear24Px: StatusGear24Px,
  statusHide20Px: StatusHide20Px,
  statusLink20Px: StatusLink20Px,
  statusLock20Px: StatusLock20Px,
  statusPending: StatusPending,
  statusSuccess20Px: StatusSuccess20Px,
  statusSumm20Px: StatusSumm20Px,
  statusSumm24Px: StatusSumm24Px,
  stopPlay: StopPlay,
  success: Success,
  switch: Switch,
  tablet: Tablet,
  taskBacklog: TaskBacklog,
  taskDone: TaskDone,
  taskInProgress: TaskInProgress,
  taskNew: TaskNew,
  taskReview: TaskReview,
  technical: Technical,
  testResultsNumberOfAttempts: TestResultsNumberOfAttempts,
  testResultsPercent: TestResultsPercent,
  testResultsRightQuestions: TestResultsRightQuestions,
  testResultsTestTime: TestResultsTestTime,
  textDown: TextDown,
  tie: Tie,
  trashDeleteBin: TrashDeleteBin,
  twitterOld: TwitterOld,
  ungroup: Ungroup,
  userApply: UserApply,
  userBlock: UserBlock,
  userEmailSentOld: UserEmailSentOld,
  userValidatedOld: UserValidatedOld,
  verticalDown: VerticalDown,
  verticalUp: VerticalUp,
  volumeHalf: VolumeHalf,
  wand: Wand,
  whileHovering: WhileHovering,
  width: Width,
  wrap: Wrap,
  zoomFit: ZoomFit,
}
